import { ForwardRefRenderFunction, forwardRef } from "react";
//#region types
import { CommentsFormTypes } from "models/formTypes";
import { FormHandles } from "models/propTypes/genericFormProps";
import { TranslationKeys } from "translations";
import { FormFieldConstants } from "utils/constants";
import { UploadedFile } from "models/utilTypes/fileUtilsTypes";
import { CommentAndFileInputFormContainerProps } from "models/propTypes/commentViewPropTypes";
import { ArraySchema } from "models/utilTypes/yupSchemaTypes";
import { StringSchema } from "yup";
//#endregion
//#region components
import CommentAndFileInputForm from "./commentAndFileInputForm";
//#endregion
import * as Yup from "yup";

const CommentAndFileInputFormContainer: ForwardRefRenderFunction<FormHandles, CommentAndFileInputFormContainerProps> = (
  props,
  ref
) => {
  const { initialValues: initialValuesFromProps, handleSubmit, commentOrFileRequired } = props;

  const initialValues: CommentsFormTypes.CommentWithFile = {
    explanation: "",
    filesToUpload: [],
    postWithoutPicture: false,
    markAsResolved: false,
    ...initialValuesFromProps,
  };

  const validationSchema = Yup.object<CommentsFormTypes.CommentWithFile>().shape(
    {
      explanation: Yup.string().when(
        [
          FormFieldConstants.Comments.CommentWithFile.MarkAsResolved,
          FormFieldConstants.Comments.CommentWithFile.FilesToUpload,
        ],
        ([markAsResolved, filesToUpload], schema: StringSchema) =>
          (((!commentOrFileRequired && !markAsResolved) || (commentOrFileRequired && !filesToUpload?.length)) &&
            schema.required(TranslationKeys.Validations.Required)) ||
          schema
      ),
      markAsResolved: Yup.boolean(),
      postWithoutPicture: Yup.boolean(),
      filesToUpload: Yup.array()
        .of(
          Yup.object<UploadedFile>({
            contentType: Yup.string(),
            fileName: Yup.string(),
            fileSize: Yup.number(),
            data: Yup.string(),
          })
        )
        .when(
          [
            FormFieldConstants.Comments.CommentWithFile.PostWithoutPicture,
            FormFieldConstants.Comments.CommentWithFile.Explanation,
          ],
          ([postWithoutPicture, explanation]: [boolean, string], schema: ArraySchema<UploadedFile>) =>
            (((!commentOrFileRequired && postWithoutPicture === false) || (commentOrFileRequired && !explanation)) &&
              schema.required(TranslationKeys.Validations.Required)) ||
            schema
        ),
    },
    [
      [
        FormFieldConstants.Comments.CommentWithFile.Explanation,
        FormFieldConstants.Comments.CommentWithFile.FilesToUpload,
      ],
    ]
  );

  const handleSubmitDefault = async (values: CommentsFormTypes.CommentWithFile) => values;

  return (
    <CommentAndFileInputForm
      ref={ref}
      {...props}
      validationSchema={validationSchema}
      defaultValues={initialValues}
      handleSubmit={handleSubmit ?? handleSubmitDefault}
    />
  );
};

export default forwardRef(CommentAndFileInputFormContainer);
